"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudioTypeToJSON = exports.AudioTypeFromJSONTyped = exports.AudioTypeFromJSON = exports.AudioType = void 0;
/**
 * The type of audio asset.
 * @export
 */
exports.AudioType = {
    AdstudioSuppliedAudio: 'ADSTUDIO_SUPPLIED_AUDIO',
    BackgroundMusic: 'BACKGROUND_MUSIC',
    StockBackgroundMusic: 'STOCK_BACKGROUND_MUSIC',
    UserUploadedAudio: 'USER_UPLOADED_AUDIO'
};
function AudioTypeFromJSON(json) {
    return AudioTypeFromJSONTyped(json, false);
}
exports.AudioTypeFromJSON = AudioTypeFromJSON;
function AudioTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.AudioTypeFromJSONTyped = AudioTypeFromJSONTyped;
function AudioTypeToJSON(value) {
    return value;
}
exports.AudioTypeToJSON = AudioTypeToJSON;
